import { TreatmentCategory } from '../../../CategoryTreatment';
import { PromotionSelect } from '../PromotionSelect';
import { PackageSelect } from '../PackageSelect';
import { TreatmentSelect } from '../TreatmentSelect';
import { PurchasedProductSelect } from '../PurchasedProductSelect';
import { agendaConst } from '../../../../../../constants';

export const TreatmentOptionSection = ({
  option,
  letOption,
  promos,
  packs,
  treatmentPackage,
  purchasedProducts,
  appointmentById,
  remainingSessions,
  onPurchasedProductChange,
  setPackageId,
  setPromotionId,
  form,
  treatmentTypeId,
}) => {
  if (!letOption) return null;

  return (
    <>
      {option === agendaConst.promotion && (
        <PromotionSelect promos={promos} setPromotionId={setPromotionId} />
      )}

      {option === agendaConst.packages && (
        <PackageSelect packs={packs} setPackageId={setPackageId} />
      )}

      {[agendaConst.promotion, agendaConst.packages].includes(option) && (
        <TreatmentSelect treatmentPackage={treatmentPackage} />
      )}

      {option === agendaConst.purchasedProducts && (
        <PurchasedProductSelect
          purchasedProducts={purchasedProducts}
          appointmentById={appointmentById}
          remainingSessions={remainingSessions}
          onPurchasedProductChange={onPurchasedProductChange}
        />
      )}

      {option === agendaConst.newTreatments && (
        <TreatmentCategory
          form={form}
          appointment={appointmentById}
          treatmentTypeId={treatmentTypeId}
        />
      )}
    </>
  );
};
